module.exports = __webpack_public_path__ + "static/img/RAKU2-ZP_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RAKU2-ZP_1.png
// module id = jCgk
// module chunks = 0